
import {createSlice} from '@reduxjs/toolkit'
import { fetchapplicationStatus } from '../../action/master/applicationStatusAction'

interface applicationStatusState {
  data: any
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: string | null
}

const initialState: applicationStatusState = {
  data: null,
  status: 'idle',
  error: null,
}

const applicationStatusSlice = createSlice({
  name: 'applicationStatus',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchapplicationStatus.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchapplicationStatus.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
        
      })
      .addCase(fetchapplicationStatus.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message || 'Failed to fetch business type data'
      })
  },
})

export default applicationStatusSlice.reducer
